import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { BsArrowRight } from "react-icons/bs";
import { BsCheckLg } from "react-icons/bs";
import activity from "../assets/activity.png";

const Activity = () => {
  return (
    <ActivityMain>
      <ActivityGrid>
        <ActivityCard>
          <img src={activity} alt="" />
        </ActivityCard>
        <ActivityCard>
          <div>
            <div className="border"></div>
            <h4>TRACK ACTIVITY</h4>
          </div>
          <h3>
            Monitor your <br /> dashboard results.
          </h3>
          <p>
            Being able to monitor everything what is going on in your business
            is crucial. Thousands of Shopify Brands have made the switch. Text
            marketing with customer in mind!
          </p>
          <ul>
            <li>
              <div>
                <BsCheckLg className="icon" />
              </div>
              Communicate 1-on-1 with customers.
            </li>
            <li>
              <div>
                <BsCheckLg className="icon" />
              </div>
              Dashboard is designed with results in mind.
            </li>
          </ul>
          <Link to="#">
            Learn more <BsArrowRight className="arrow" />
          </Link>
        </ActivityCard>
      </ActivityGrid>
    </ActivityMain>
  );
};

export default Activity;

const ActivityMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem calc((100vw - 1200px) / 2);
  padding-top: 0rem;

  @media only screen and (max-width: 991px) {
    padding-top: 4rem;
  }
`;

const ActivityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 500px;
  grid-gap: 0rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin-left: 35px;
  }
`;

const ActivityCard = styled.div`
  position: relative;
  img {
    position: absolute;
    left: 22%;
    /* width: 65%;
    height: 100%; */
  }
  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 0px;
    .border {
      background-color: #3aaa35;
      height: 3px;
      width: 45px;
    }
    h4 {
      text-transform: uppercase;
      font-weight: 500;
      font-size: 18px;
      margin-left: 15px;
      color: #3aaa35;
    }
  }
  h3 {
    font-size: 45px;
    font-weight: 600;
    color: #20204f;
    line-height: 65px;
    margin-top: 15px;
  }
  p {
    margin-top: 20px;
    font-weight: 500;
    color: #535353;
    width: 80%;
  }
  ul {
    margin-top: 1.5rem;
    li {
      display: flex;
      margin-bottom: 10px;
      color: #333;
      font-weight: 500;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #9be2aa;
        border: 2px solid #3aaa35;
        height: 22px;
        width: 22px;
        border-radius: 50%;
        margin-right: 7px;
      }
      .icon {
        font-size: 16px;
        color: #0ea506;
      }
    }
  }
  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #20204f;
    text-decoration: none;
    font-weight: 500;
    font-size: 18px;
    margin-top: 1.5rem;

    .arrow {
      color: #20204f;
      margin-left: 10px;
      font-weight: 500;
    }
  }
  &:nth-child(2) {
    margin-left: -25px;
  }
  @media only screen and (max-width: 991px) {
    &:nth-child(1) {
      grid-row: 2/ 3;
      grid-column: 1/ 2;
      margin-bottom: 30rem;
    }
    img {
      left: 0%;
      width: 92%;
      margin-top: 2rem;
    }
    h3 {
      font-size: 40px;
      font-weight: 600;
      color: #20204f;
      line-height: 48px;
      margin-top: 15px;
    }
    p {
      margin-top: 20px;
      font-weight: 500;
      color: #535353;
      width: 100%;
    }
  }
`;
